(function () {
  class WinController {
    constructor() {
      this._batcher = undefined;
      this._winlineAnimator = undefined;
      this._symbolAnimator = undefined;
      this._active = false;
      this._skipped = false;
      this._highWinSounds = ["winHigh1", "winHigh2", "winHigh3"];
      this._lowWinSounds = ["winLow1", "winLow2", "winLow3"];
    }

    initialise(json) {
      if (gdk.mustShowSlowWin()) {
        this._batcher = resourceManager.getSharedPlugin(json.batcher_slow);
      } else {
        this._batcher = resourceManager.getSharedPlugin(json.batcher_normal);
      }
      this._symbolAnimator = json.symbolAnimator ? resourceManager.get(json.symbolAnimator) : undefined;
      this._winlineAnimator = json.winlineAnimator ? resourceManager.getSharedPlugin(json.winlineAnimator) : undefined;
    }

    startAnimations(winData, celebrationThreshold, slotMachine, completeCallback) {
      let self = this;
      self._active = true;
      let canCelebrate = winData.totalLineWinnings > celebrationThreshold;
      let sequenceData = this._batcher.batch(winData, celebrationThreshold);
      this._skipped = false;

      let currentSequence = 0;
      let playNextSequence = function (i) {
        if (canCelebrate) {
          // hunters moon hack, only play symbol win soun don the all batch
          let bestSymbolWin = -1;
          if (currentSequence === 0) {
            for (let j = 0; j < sequenceData[i].length; ++j) {
              if (sequenceData[i][j].winId > bestSymbolWin) {
                bestSymbolWin = sequenceData[i][j].winId;
              }
            }
          } else {
            bestSymbolWin = 0;
          }

          // Play the win sound here based on win amount
          const winnings = winData.totalLineWinnings;
          const stake = gameController.getCurrentModeStake();
          if (winnings <= stake) {
            soundManager.play("winLTS");
          } else if (winnings < stake * 10) {
            const randIndex = Math.floor(Math.random() * self._lowWinSounds.length);
            soundManager.play(self._lowWinSounds[randIndex]);
          } else {
            const randIndex = Math.floor(Math.random() * self._highWinSounds.length);
            soundManager.play(self._highWinSounds[randIndex]);
          }
        }

        let linesToPlay = [];

        for (let j = 0; j < sequenceData[i].length; ++j) {
          linesToPlay.push(sequenceData[i][j].winline);
        }

        let uniqueArray = linesToPlay.filter(function (item, pos) {
          return linesToPlay.indexOf(item) == pos;
        });

        let winlines = [];
        for (let j = 0; j < uniqueArray.length; ++j) {
          winlines.push(winData.winningLines[uniqueArray[j]]);
        }

        // late hunters moon hack
        let loop = currentSequence === 0;
        let showWinCounter = currentSequence > 0;

        if (self._symbolAnimator) {
          // make a copy of the sequence data array
          // and filter out symbols on reel 7 if the devil is visible
          // otherwise we see the odd flicker of horns
          const sd = sequenceData[i].slice(0).filter((data) => {
            let keep = true;
            if (data.cell.reel === 7 && gameController.centreDevil.devilVisible === true) {
              keep = false;
            }
            return keep;
          });

          self._symbolAnimator.animateSymbols(
            sd,
            slotMachine,
            canCelebrate,
            false,
            function () {
              ++currentSequence;
              if (currentSequence >= sequenceData.length || self._skipped) {
                self._active = false;
                completeCallback();
              } else {
                if (self._skipped) {
                  self._active = false;
                  completeCallback();
                } else {
                  playNextSequence(currentSequence);
                }
              }
            },
            function () {}
          );
        }
      };
      playNextSequence(currentSequence);
    }

    isActive() {
      return this._active;
    }

    skipAnimations() {
      if (this.isActive()) {
        this._skipped = true;
        this._symbolAnimator.skip();
        if (this._winlineAnimator) this._winlineAnimator.skipAnimation();
      }
    }
  }

  let createWinController = function () {
    return new WinController();
  };

  resourceManager.registerController("WinControllerAllAtOnce", createWinController);
})();
